import { spaceProp } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled, { css } from 'styled-components';
import { getGridGutterStyle, getRowGridGutterStyle } from './helpers/getGutterStyle.js';

const StyledGrid = styled.div.withConfig({
    shouldForwardProp: (prop) => !['gutterRows', 'gutter', 'spaceAfter'].includes(prop),
}) `
  display: flex;
  flex-wrap: wrap;
  ${({ gutter }) => typeof gutter !== 'undefined' && getGridGutterStyle(gutter)};
  ${({ gutterRows }) => typeof gutterRows !== 'undefined' && getRowGridGutterStyle(gutterRows)};

  ${({ spaceAfter }) => spaceAfter &&
    css `
      ${spaceProp(spaceAfter)};
    `};
`;
const Grid = withExtra((props) => {
    const { children, gutter, spaceAfter, className, gutterRows, as } = props;
    const clonedChildrenWithProps = React.Children.map(children, (child) => child ? React.cloneElement(child, { gutter, gutterRows }) : null);
    return (React.createElement(StyledGrid, { as: as, gutter: gutter, gutterRows: gutterRows, spaceAfter: spaceAfter, className: className }, clonedChildrenWithProps));
}, { name: 'Grid' });

export { Grid };
//# sourceMappingURL=Grid.js.map
